var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.messages.length > 0 ? _c('div', {
    staticClass: "toast-wrapper"
  }, [_c('div', {
    staticClass: "toast-container"
  }, _vm._l(_vm.messages, function (msg) {
    return _c('div', {
      key: msg.id,
      staticClass: "toast-msg"
    }, [_c('div', {
      staticClass: "toast-msg__header",
      style: `
                    border-color: ${msg.color || 'var(--theme-tertiary)'};
                    background-color: ${_vm.getHeaderBg(msg.color || 'var(--theme-tertiary)')};
                `
    }, [msg.title ? _c('strong', {
      staticClass: "toast-msg__title"
    }, [_vm._v(_vm._s(msg.isTranslation ? _vm.$t(msg.title) : msg.title))]) : _vm._e(), _c('button', {
      staticClass: "toast-msg__close",
      on: {
        "click": function ($event) {
          return _vm.dismiss(msg.id);
        }
      }
    }, [_vm._v("×")])]), _c('div', {
      staticClass: "toast-msg__body"
    }, [_vm._v(" " + _vm._s(msg.isTranslation ? _vm.$t(msg.message) : msg.message) + " "), msg.link ? _c('a', {
      staticClass: "toast-msg__link",
      attrs: {
        "href": msg.link,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(_vm._s(msg.linkText || msg.link))]) : _vm._e(), msg.description ? _c('p', {
      staticClass: "toast-msg__description"
    }, [_vm._v(" " + _vm._s(msg.description) + " ")]) : _vm._e()])]);
  }), 0), _vm.messages.length > 1 ? _c('button', {
    staticClass: "toast-clear-all",
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._v(" Clear All ")]) : _vm._e()]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }